import { render, staticRenderFns } from "./FiltroMatricula.vue?vue&type=template&id=656185da&"
import script from "./FiltroMatricula.vue?vue&type=script&lang=js&"
export * from "./FiltroMatricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports